export default __webpack_public_path__ + "static/media/node.6513a8b0.svg";